import React from "react";
import { EyeOff } from "lucide-react";
import { Badge } from "./ui/badge";

/**
 * Visual indicator that a document is hidden from non-privileged users
 * via the Sunprojects-only Incognito Mode. Renders nothing if `is_incognito`
 * is falsy.
 *
 * @param {boolean} active - The is_incognito flag from the document.
 * @param {"sm"|"md"} size - sm = inline list usage, md = detail header
 * @param {string} className - extra classes
 */
export default function IncognitoBadge({ active, size = "sm", className = "" }) {
  if (!active) return null;
  const sizeCls = size === "md" ? "text-xs px-2.5 py-1" : "text-[10px] px-1.5 py-0.5";
  const iconSize = size === "md" ? "h-3.5 w-3.5" : "h-3 w-3";
  return (
    <Badge
      variant="outline"
      data-testid="incognito-badge"
      className={`gap-1 border-purple-500 bg-purple-50 text-purple-800 font-semibold ${sizeCls} ${className}`}
      title="Dieses Dokument ist im Inkognito-Modus und für andere User unsichtbar"
    >
      <EyeOff className={iconSize} />
      <span>Inkognito</span>
    </Badge>
  );
}
